export default "__VITE_ASSET__B36W6Mi6__"